export default "__VITE_ASSET__ozhjcrw7__"